export default __webpack_public_path__ + "static/2474-1098b5ab53906a7cefeda1cacfc29005.gif";